import { Principal } from '@icp-sdk/core/principal'
import { Signer } from '@slide-computer/signer'
import { SignerAgent } from '@slide-computer/signer-agent'
import { PostMessageTransport } from '@slide-computer/signer-web'

const oisySigner = new Signer({
  transport: new PostMessageTransport({
    url: 'https://oisy.com/sign',
    windowOpenerFeatures: 'width=525,height=705',
    establishTimeout: 45000,
    disconnectTimeout: 45000,
    detectNonClickEstablishment: false,
  }),
})

const oisyAgent = SignerAgent.createSync({
  signer: oisySigner,
  account: Principal.anonymous(),
})

export const connectOisy = async (): Promise<{ principal: string }> => {
  const accounts = await oisySigner.accounts()
  if (!accounts || accounts.length === 0) {
    throw new Error('Failed to get principal ID from Oisy')
  }

  const principal = accounts[0].owner
  oisyAgent.replaceAccount(principal)

  return { principal: principal.toString() }
}

export const disconnectOisy = async (): Promise<void> => {
  await oisySigner?.closeChannel()

  oisyAgent.replaceAccount(Principal.anonymous())
}

export const getOisyAgent = () => oisyAgent
